/**
 * Returns the user agent string from the browser environment.
 *
 * @param toLowercase - Whether to convert the user agent to lowercase (default: false).
 * @returns The user agent string, or an empty string if not running in a browser environment.
 */
export function getUserAgent(toLowercase: boolean = false): string {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') {
        return '';
    }
  
    const user_agent: string = navigator.userAgent 
                                || navigator.vendor 
                                || (window as any).opera 
                                || '';
  
    return toLowercase ? user_agent.toLowerCase() : user_agent;
}